import { useQuery, UseQueryOptions } from 'react-query';
import client from 'client';
import { SessionRating } from './type';

const fetchSessionRating = async (eventId: number, sessionId: number) => {
    const response = await client().get(
        `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/rate`
    );

    const result: SessionRating = {
        rate: response.data?.rate ?? 0,
        feedback: response.data?.feedback ?? '',
    };

    return result;
};

const useSessionRating = (
    eventId: number,
    sessionId: number,
    options?: UseQueryOptions<SessionRating>
) => {
    return useQuery(
        ['sessionRating', eventId, sessionId],
        () => fetchSessionRating(eventId, sessionId),
        { ...options }
    );
};

export default useSessionRating;
